VjsAdmin.DistrictFeatures = (function () {
    const init = function () {
        const controller = new FeatureEditController();
        if (!VjsAdmin.hasPermission('platforms.districts.features.edit')) {
            controller.disableFeatureCheckboxes();
        }
    };

    let FeatureEditController = VjsUtility.Controller.extend({
        events: {
            'click #save-district-features-button': 'clickSaveFeatureButton',
            'click .product-radio': 'clickProductCheckbox',
        },
        clickSaveFeatureButton() {
            const selectedProducts = $('.product-radio:checked')
                .map((i, product) => product.dataset.productId)
                .get();

            const selectedFeatures = $('.feature-checkbox:checked')
                .map((i, feature) => feature.dataset.featureId)
                .get();

            const featureFormData = {
                district_joint_guid: document.getElementById('district-feature-form').dataset.districtJointGuid,
                platform_id: document.getElementById('district-feature-form').dataset.platformId,
                product_ids: selectedProducts,
                feature_ids: selectedFeatures,
            };

            const req = new VjsUtility.Request();
            req.put(Slim.Router.pathFor('api.district.features.edit'), featureFormData)
                .done(() => {
                    VjsUtility.Notification.success({
                        text: 'District features successfully updated',
                        time: 3500,
                    });
                })
                .fail(() => {
                    VjsUtility.Notification.error({
                        text: 'Error updating district features',
                        time: 3500,
                    });
                });
        },
        clickProductCheckbox(e) {
            const req = new VjsUtility.Request();

            req.get(
                Slim.Router.pathFor('api.product.features.get', {
                    id: e.target.dataset.productId,
                }),
                {
                    platform_id: document.getElementById('district-feature-form').dataset.platformId,
                },
            )
                .done((res) => {
                    const featureIds = res.data.data.features.map((feature) => feature.id);
                    const featureCheckboxes = $('.feature-checkbox');

                    featureCheckboxes.each((i, feature) => {
                        if (featureIds.includes(+feature.dataset.featureId)) {
                            feature.checked = true;
                        } else {
                            feature.checked = false;
                        }
                    });
                })
                .fail(() => {
                    VjsUtility.Notification.error({
                        text: `Cannot get features for product ${e.target.dataset.productName}. 
                                You will need to select features manually.`,
                        time: 3500,
                    });
                });
        },
        disableFeatureCheckboxes() {
            $('.feature-checkbox').prop('disabled', true);
        },
    });

    return {
        init,
    };
}());
